var alignment_default = {
  "alignLeft": "Y0khg",
  "textWrapNowrap": "g3kHM",
  "alignRight": "BzQKU",
  "alignCenter": "NY-QD",
  "sizeFullWidth": "_0Z9DY",
  "renderedInTable": "fwEUh",
  "sizeOriginal": "NwCLa",
  "sizeContent": "_50Ywj",
  "sizeSmall": "eX7c9",
  "sizeSmallCenter": "_0a1LY",
  "flex": "sFMd1",
  "LEFT": "_6lkns",
  "CENTER": "Vbf1a",
  "RIGHT": "NcJLH",
  "AUTO": "_0uG9a",
  "JUSTIFY": "jswSl"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
